module.exports = __webpack_public_path__ + "static/media/dashboardWhite.7e9f592d.svg";